export enum SubscriptionGivingAccessSettingEnum {
  immediately = 'immediately',
  only_after_first_payment = 'only_after_first_payment',
}

export const SubscriptionGivingAccessSettingEnumTitles = {
  [SubscriptionGivingAccessSettingEnum.immediately]:
    'dashboard.settings.payment_page.give_access_immediately',
  [SubscriptionGivingAccessSettingEnum.only_after_first_payment]:
    'dashboard.settings.payment_page.give_access_only_after_first_payment',
}
